// GA4 is deliberately limited to the signup funnel. The rest of the app has
// magic-link, invite and reset tokens plus record IDs in its URLs, which must
// never reach a third party. Consent comes from the marketing site's cookie.

const GA_ID = 'G-CR5MH6T0YL'
const PROD_HOST = 'app.certslate.com'
const INTENT_KEY = 'cs_signup_intent'

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

function consentGranted(): boolean {
  return document.cookie.split('; ').includes('cs_consent=granted')
}

let ready = false

function init(): boolean {
  if (ready) return true
  if (location.hostname !== PROD_HOST || !consentGranted()) return false

  const dataLayer = (window.dataLayer = window.dataLayer || [])
  window.gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    dataLayer.push(arguments)
  }
  window.gtag('consent', 'default', {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    analytics_storage: 'granted',
  })
  window.gtag('js', new Date())
  window.gtag('config', GA_ID, { send_page_view: false })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  document.head.appendChild(script)

  ready = true
  return true
}

function referrerOrigin(): string {
  try {
    return document.referrer ? new URL(document.referrer).origin : ''
  } catch {
    return ''
  }
}

// Path only: the success page URL carries the Stripe checkout session id.
export function trackFunnelPageView() {
  if (!init()) return
  window.gtag?.('event', 'page_view', {
    page_location: location.origin + location.pathname,
    page_path: location.pathname,
    page_referrer: referrerOrigin(),
  })
}

export function trackBeginCheckout(plan: string, value: number) {
  if (!init()) return
  try {
    sessionStorage.setItem(INTENT_KEY, JSON.stringify({ plan, value }))
  } catch {
    // storage unavailable: the sign_up event just won't carry the plan
  }
  window.gtag?.('event', 'begin_checkout', {
    transport_type: 'beacon',
    currency: 'GBP',
    value,
    plan,
  })
}

export function trackSignUp(checkoutSessionId: string) {
  if (!init()) return

  const doneKey = `cs_signup_tracked_${checkoutSessionId}`
  let intent: { plan?: string; value?: number } = {}
  try {
    if (sessionStorage.getItem(doneKey)) return
    sessionStorage.setItem(doneKey, '1')
    intent = JSON.parse(sessionStorage.getItem(INTENT_KEY) ?? '{}')
  } catch {
    // fall through with whatever we have
  }

  window.gtag?.('event', 'sign_up', {
    transport_type: 'beacon',
    method: 'stripe_checkout',
    currency: 'GBP',
    ...intent,
  })
}
